import { render, staticRenderFns } from "./SystemCustomNotificationsSendNotification.vue?vue&type=template&id=c525799a&scoped=true"
import script from "./SystemCustomNotificationsSendNotification.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotificationsSendNotification.vue?vue&type=script&lang=js"
import style0 from "./SystemCustomNotificationsSendNotification.vue?vue&type=style&index=0&id=c525799a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c525799a",
  null
  
)

export default component.exports